var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#messages_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5,
  d: "M12.29 7.48V2.3A1.3 1.3 0 0 0 11 1H2.29A1.3 1.3 0 0 0 1 2.3v5.18a1.3 1.3 0 0 0 1.29 1.3h.37v1.56a.52.52 0 0 0 .52.53.51.51 0 0 0 .39-.19l1.64-1.9H11a1.3 1.3 0 0 0 1.29-1.3ZM5 8.08a.34.34 0 0 0-.26.12L3.36 9.85V8.43A.36.36 0 0 0 3 8.07h-.71a.59.59 0 0 1-.59-.59V2.3a.59.59 0 0 1 .59-.59H11a.59.59 0 0 1 .59.59v5.18a.6.6 0 0 1-.59.6zm8.67-4.95a.36.36 0 0 0 0 .71.6.6 0 0 1 .59.59v5.18a.6.6 0 0 1-.59.6H13a.35.35 0 0 0-.35.35V12l-1.43-1.67a.34.34 0 0 0-.22-.12H5.69a.36.36 0 0 0 0 .71h5.1l1.64 1.9a.5.5 0 0 0 .39.18H13a.52.52 0 0 0 .34-.49v-1.6h.37A1.3 1.3 0 0 0 15 9.61V4.43a1.3 1.3 0 0 0-1.29-1.3z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "messages_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v14H0z"
})))));
export default SvgMessages;